import moment from "moment-timezone";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Combobox } from "@/components/ui/combobox";
import { CommonDestinationTimezone } from "@/lib/utils";
import { SelectOptionItem } from "@/lib/models/ui";

const CROP_YEAR_OPTION_COUNT = 10;
const CROP_YEAR_START_OFFSET = 3;

interface CropYearFieldProps {
  value: string;
  error?: string;
  onChange: (v: string) => void;
  isEditable: boolean;
  /**
   * Crop year doubles as the row that owns the linked-order toggle, because
   * the link picker sits directly beneath it in the form.
   */
  linkedOrderEnabled: boolean;
  onChangeLinkedOrderEnabled: (enabled: boolean) => void;
}

export function CropYearField({
  value,
  error,
  onChange,
  isEditable,
  linkedOrderEnabled,
  onChangeLinkedOrderEnabled,
}: CropYearFieldProps) {
  const currentYear = parseInt(moment.tz(CommonDestinationTimezone).format("YYYY"));
  const options: SelectOptionItem<string>[] = Array.from({ length: CROP_YEAR_OPTION_COUNT }, (_, i) => {
    const year = currentYear - i + CROP_YEAR_START_OFFSET;
    return { value: year.toString(), label: year.toString() };
  });

  return (
    <div className="flex flex-row gap-2">
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-3">
        <Label>
          Crop Year <span className="text-destructive">*</span>
        </Label>
      </div>
      <div>
        <Combobox
          disabled={!isEditable}
          dwimOnChange
          isModal={false}
          placeholder="Select crop year..."
          options={options}
          value={value}
          virtualizeList
          popoverClassName="w-[420px] h-[300px]"
          onValueChange={onChange}
        />
      </div>
      {error && <p className="text-destructive text-xs">{error}</p>}
    </div>
        <div className="flex items-center gap-2">
          <Checkbox
            disabled={!isEditable}
            id="ttv2-link-order"
            checked={linkedOrderEnabled}
            onCheckedChange={(c) => onChangeLinkedOrderEnabled(c === true)}
          />
          <Label htmlFor="ttv2-link-order" className="font-bold cursor-pointer">
            Uses Multiple Orders
          </Label>
        </div>
    </div>
  );
}
